const MILESTONES: { year: string; desc: string }[] = [
  { year: '2025', desc: '공공데이터포털 및 대국민 서비스 위탁운영 수행' },
  { year: '2024', desc: '특정행정심판 재결례·중앙부처 법령해석 등 국가중점데이터 API 구축' },
  { year: '2023', desc: '사업용차량 이력정보·SRT 지연승차권 등 신규 데이터 개방 확대' },
  { year: '2021', desc: '금융표준종합정보 DB 개방 확대 및 사업자등록정보 진위확인 서비스' },
  { year: '2020', desc: '범정부 데이터 플랫폼 통합 운영·유지보수 사업 수행' },
  { year: '2019', desc: '공공데이터포털 위탁 운영 및 서비스 개선 사업' },
];

/**
 * 연혁 — 스텝형 타임라인.
 * 대형 "since 2016" 배지 없이 성과 중심으로 표기한다.
 */
export default function HistoryTimeline() {
  return (
    <section className="pd-section pd-history">
      <div className="pd-container">
        <div className="pd-head">
          <span className="pd-eyebrow pd-eyebrow--plain">MILESTONES</span>
          <h2 className="pd-h2">공공데이터포털 운영의 발자취</h2>
        </div>

        <div className="pd-history__list">
          {MILESTONES.map((m) => (
            <div className="pd-history__item" key={m.year}>
              <div className="pd-history__year">{m.year}</div>
              <div className="pd-history__desc">{m.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
